import { Suspense } from "react";
import BookingHistoryPage from "@/app/booking/history/history";
import BookingHistorySkeleton from "@/components/booking-history-skeleton";

export default function BookingHistoryPageWrapper() {
  return (
    <Suspense fallback={<BookingHistorySkeleton />}>
      <BookingHistoryPage />
    </Suspense>
  );
}
